function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "22",
  viewBox: "0 0 14 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.024 10.314h0L2.194.733 2.191.73A.915.915 0 00.895.81h0a.916.916 0 00.08 1.294s0 0 0 0L11.034 11 .976 19.897a.915.915 0 00.607 1.603.911.911 0 00.608-.231l.002-.001 10.83-9.582h.002a.916.916 0 000-1.372z",
  fill: "#DA291C",
  stroke: "#DA291C"
})));